import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelDestinationEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelDestinationEntity
